import React, { useContext } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import { RacingContext } from '../Home/RacingPage';
import { getSiteCoreImagePath, getMenuParamByName, NewWindowWithProps } from '../Common/home-common';
import { glassboxCustomEvent } from '../Common/utils/glassbox';
import { redirectJCRW } from '../Racing/Common/Common';
import { textFormatAmountFn } from '../Common/GlobalFunc';


export const handleClickMenuItem = (event, menu, handleOnPageChange) => {
    if (menu.itemRedirection?.value === window.sitecoreVars.REDIRECT_JCBW_PAGE && menu.itemPage?.value !== '') {
        handleOnPageChange(menu.itemPage.value);
    } else if (menu.itemLink.value !== '') {
        if (menu.redirectMethod?.value === window.sitecoreVars.REDIRECT_POPUP) {
            let winProps = getMenuParamByName(menu);
            if (menu?.pCardEnable?.value === "1" && sessionStorage.getItem('enableEwinLP') === '1') {
                let toUrl = menu.itemLink.value + (sessionStorage.getItem('PCardTier') ? '&qitTierCode=' + sessionStorage.getItem('PCardTier') : '');
                window.popupWindow = NewWindowWithProps(toUrl, menu.key, winProps);
            } else {
                NewWindowWithProps(menu.itemLink.value, menu.key, winProps);
            }
            event.currentTarget.blur();
        } else if (menu.redirectMethod?.value === window.sitecoreVars.REDIRECT_REPLACETAB) {
            redirectJCRW(menu.itemLink.value);
            //NewWindowWithProps(menu.itemLink.value, '_self');
        } else {
            window.open(menu.itemLink.value);
        }
    }

    if (menu.GlassboxTaggingEnabled?.value == '1') {
        const name = menu.GlassboxCustomEventName?.value || "";
        const value = menu.GlassboxCustomEventValue?.value || "";
        if (name != "" && value != "") {
            glassboxCustomEvent(name, value);
        }
    }
};

export const highLightLeftMenuItem = (item, context, product) => {
    let { page, matchId } = useParams();
    if ( !page ) {
        page = 'home';
    }
    page =page.toUpperCase();
    switch (product) {
        case 'racing':
            if (['WPALUP', 'WPQALUP', 'FCTALUP', 'TRIALUP'].includes(page)) {
                page = page.replace('ALUP', '');
            }
            break;
        case 'football':
            if (page === 'INPLAY_ALL') {
                if(`${page}/${matchId}`.toUpperCase() === item.toUpperCase()) return true
                page = 'INPLAY';
                matchId = null ;
            }
            if (page === 'ALLODDS') {
                if(`${page}/${matchId}`.toUpperCase() === item.toUpperCase()) return true
                matchId = null ;
            }
            if(item.includes('?') && location.href.includes(item) && item.includes(sessionStorage.getItem('hlTournMatchMenu'))) return true
            break;
    }
    return matchId ? `${page}/${matchId}`.toUpperCase() === item.toUpperCase() : page.toUpperCase() === item.toUpperCase();
};

export const isProductInfoItemEnable = (menu) => {
    if (menu.itemEnable.value !== '1') {
        return false;
    }
    return true;
};

export const isMenuWithinDate = (menu, dt) => {
    let emptyDt = '0001-01-01T08:00:00';
    if (menu.fromDate?.value !== emptyDt && moment(menu.fromDate?.value) > dt) {
        return false;
    }
    if (menu.toDate?.value !== emptyDt && moment(menu.toDate?.value) < dt) {
        return false;
    }
    return true;
};

export const isMenuOverDate = (menu, dt) => {
    let emptyDt = '0001-01-01T08:00:00';
    if (menu.startDatetime && menu.startDatetime.value !== emptyDt && moment(menu.startDatetime.value) > dt) {
        return false;
    }
    return true;
};

export const getRCBetType = (typ) => {
    let t = typ.toUpperCase();
    switch (t) {
        case '6UP':
            t = 'SixUP';
            break;
        case 'WP':
            t = ['WIN', 'PLA']
    }
    return t;
};

export const LeftMenuIcon = ({ menu, cashOutNo }) => {
    const { t, i18n } = useTranslation();
    const racingContext = useContext(RacingContext);
    if (menu.jpFlag?.value === '1') {
        let bType = getRCBetType(menu.itemPage.value);
        let mtg = racingContext?.content?.meeting;
        // need to handle wp jackpot morethan 0 to show label
        if (mtg != null) {
            const mobileShowStatus = (item) => {
                return (racingContext?.windowSize?.isMobileSize && racingContext?.content?.raceNo == item.leg.races[0]) || !racingContext?.windowSize?.isMobileSize;
            }
            if (
                mtg.jpEsts.filter(
                    (x) => {
                        const currentRace = mtg.races?.find(race => race.no === x.leg.races[0])
                        const isFinishedRace =  ["RESULT", 'VOIDED', 'CLOSED', 'ABANDONED'].includes(currentRace?.status?.toUpperCase())
                        return [].concat(bType).includes(x.oddsType) && (x.jackpot && !isNaN(x.jackpot)) 
                        && (menu.itemPage.value === 'wp' ? parseInt(x?.jackpot) > 0 : true) && x.leg.races[0] >= mtg.currentNumberOfRace && !isFinishedRace && mobileShowStatus(x)}
                ).length > 0
            ) {
                return (
                    <span className="leftMenuIcon">
                        <img
                            id={`${menu.itemPage.value}_jackpot_icon`}
                            src={getSiteCoreImagePath(menu.itemIcon.src, i18n.language)}
                            width={menu.itemIcon.width}
                            height={menu.itemIcon.height}
                            title={menu.altTxt.value}
                        />
                        <span className='jackpot_text'>{t('LB_RC_JACKPOT')}</span>
                    </span>
                );
            }
        }
    } else if (menu.sectionIcon?.src) {
        return (
            <span className="leftMenuIcon">
                <img
                    src={getSiteCoreImagePath(menu.sectionIcon.src, i18n.language)}
                    width={menu.sectionIcon.width}
                    height={menu.sectionIcon.height}
                    title={menu.altTxt?.value}
                />
            </span>
        );
    } else if (menu.itemIcon?.src) {
        return (
            <span className="leftMenuIcon">
                <img
                    src={getSiteCoreImagePath(menu.itemIcon.src, i18n.language)}
                    width={menu.itemIcon.width}
                    height={menu.itemIcon.height}
                    title={menu.altTxt?.value}
                />
                {cashOutNo ? cashOutNo : null}
            </span>
        );
    }
    return null;
};

export const LeftMenuJackpotIcon = ({ menu, mtg, curJpEsts }) => {
    const { t, i18n } = useTranslation();
    const racingContext = useContext(RacingContext);
    if (menu.jpFlag?.value === '1') {
        // need to handle wp jackpot morethan 0 to show label
        if (mtg != null) {
            
            if (
                curJpEsts.length > 0
            ) {
                let jackpotText = t('LB_RC_JACKPOT')
                if(racingContext?.windowSize?.isMobileSize && curJpEsts.length == 1){
                    jackpotText = `$${textFormatAmount(curJpEsts[0]?.jackpot, i18n.language)}`
                }
                return (
                    <span className="leftMenuIcon jackpot">
                        <img
                            id={`${menu.itemPage.value}_jackpot_icon`}
                            src={getSiteCoreImagePath(menu.itemIcon.src, i18n.language)}
                            width={menu.itemIcon.width}
                            height={menu.itemIcon.height}
                            title={menu.altTxt.value}
                        />
                        <span className='jackpot_text'>{jackpotText}</span>
                    </span>
                );
            }
        }
    } 
    return null;
};

export const MergedPoolLabel = ({ menu, product}) =>{
    const { t, i18n } = useTranslation();
    const racingContext = useContext(RacingContext);
    let bType = getRCBetType(menu.itemPage.value);
    let mtg = racingContext?.content?.meeting;
    let currentPool = mtg?.poolInvs?.find(i => i.oddsType === bType && i.leg.races[0] === racingContext?.content?.raceNo)
    if(currentPool?.mergedPoolId){
        // let mergedBetType = mtg?.poolInvs?.find(i => i.oddsType !== bType && i.mergedPoolId === currentPool?.mergedPoolId)?.oddsType
        return <div className='mergedPoolLabel'>{t(`LB_RC_MERGED_POOL_${currentPool.oddsType}`)}</div>
    }
   return null
}

export const MenuIcon = ({ menu, cashOutNo }) => {
    const { i18n } = useTranslation();
    if (menu.itemIcon?.src) {
        return (
            <div className="leftMenuIcon">
                <img
                    src={getSiteCoreImagePath(menu.itemIcon.src, i18n.language, menu.itemIcon.isLocalSrc)}
                    width={menu.itemIcon.width}
                    height={menu.itemIcon.height}
                    title={menu.altTxt?.value}
                />
                {cashOutNo ? cashOutNo : null}
            </div>
        );
    }
    return null;
};

export const IconContent = ({ iconContent }) => {
    const { i18n } = useTranslation();
    if (iconContent?.src) {
        return (
            <div className="leftMenuIcon">
                <img
                    src={getSiteCoreImagePath(iconContent.src, i18n.language)}
                    width={iconContent.width}
                    height={iconContent.height}
                    title={iconContent.alt}
                />
            </div>
        );
    }
    return null;
};

export const BottomMenuIcon = ({ menu, active }) => {
    const { i18n } = useTranslation();
    if (menu.itemIcon?.src) {
        return (
            <img
                src={getSiteCoreImagePath(active && menu?.filledIcon?.src ? menu?.filledIcon?.src : menu.itemIcon.src, i18n.language, menu.itemIcon.isLocalSrc)}
                width={menu.itemIcon.width}
                height={24}
                title={menu.altTxt?.value}
            />
        );
    }
    return null;
};

export const hasChpTypePool = (type, chpTypes) => {
    if ( chpTypes!=null ) {
        for ( let i=0; i<chpTypes.length; i++ ) {
            if ( chpTypes[i].foPools?.filter(item=> item.chpType===type).length>0 ) {
                return true;
            }
        }
    }
    return false;
}

const textFormatAmount = (amount, lang) =>{

    if(amount % 1000 > 0 || amount < 10000) return textFormatAmountFn(amount,0)
    if(lang == 'en'){
        if(amount < 1000000){
            let newAmount = amount / 1000
            return `${newAmount}K`
        }else if(amount < 1000000000){
            let newAmount = amount / 1000000
            return `${newAmount}M`
        }else{
            let newAmount = amount / 1000000000
            return `${newAmount}B`
        }
    }else if(lang === 'ch'){
        if(amount < 100000000){
            let newAmount = amount / 10000
            return `${newAmount}萬`
        }else{
            let newAmount = amount / 100000000
            return `${newAmount}億`
        }
    }
    return textFormatAmountFn(amount,0)
}